

import PageRouter from "@/router/PageRouter";
import ExampleRouter from "@/router/ExampleRouter";

/**
 * 이 라우터는 Main 의 하위 라우터입니다.
 *
 * 로그인 전과 로그인 후의 라우터를 분기합니다.
 */
const MainRouter = [
    /**
     * 예제 샘플
     */
    {
        path: "example",
        name: "example",
        component: () => import('../views/example/ExampleView'),// 예제
        children: ExampleRouter,
    },
    {
        path: "home/main",
        name: "home.main",
        component: () => import(/* webpackChunkName: "main" */ '../views/home/HomeMain'), // 메인
        children: PageRouter,
    },
    {
        path: "style/mainFrame",
        name: "style.mainFrame",
        component: () => import('../views/home/style/MainFrame'),// 퍼블 화면
    },

]

export default MainRouter;